/* The arrows turn a page, not a card: they move by as many slides as are on screen.
   keen-slider only ever steps one slide (`next` is `moveToIdx(abs + 1)`), so the
   paging arithmetic is ours. Kept pure and separate so it can be unit tested. */

/** The furthest index the track can rest on: the first slide of the final full view.
 *  Matches keen's `track.details.maxIdx` for a non-looping slider. */
export const lastPageIndex = (slideCount: number, perView: number) => Math.max(slideCount - perView, 0);

/** Turn one page forward, stopping on the last full view rather than overshooting —
 *  a row of 4 at 3-per-view advances by 1, because only 1 new card exists. Clamping
 *  here matters: keen silently ignores an out-of-range index, which would leave the
 *  arrow looking dead. */
export const nextPageIndex = (current: number, perView: number, slideCount: number) =>
    Math.min(current + perView, lastPageIndex(slideCount, perView));

export const previousPageIndex = (current: number, perView: number) => Math.max(current - perView, 0);
